import * as yup from 'yup';
import { object } from 'yup';
import { LinkCardOption } from '../../shared';
import { useMemo } from 'react';

export function useCardSchema() {
    return useMemo(
        () =>
            object().shape({
                action: yup.string(),
                code: yup
                    .string()
                    .when('action', ([action], schema) =>
                        action === LinkCardOption.EXISTING_CARD ? schema.required() : schema,
                    ),
            }),
        [],
    );
}
